import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/Login/Login.vue'
import support4iQ from '../components/Login/support4iQ.vue'
import authenticationdocs from '../components/Login/authenticationdocs'

Vue.use(Router)

var loginRoutes = [
    {
        path: '/',
        name: Login,
        component: Login
    },
    {
        path: '/support4iQ',
        name: support4iQ,
        component: support4iQ
    },
    {
        path: '/2fadocs',
        name: authenticationdocs,
        component: authenticationdocs
    },
    {   path: "*", 
        redirect: '/' 
    }
    ];

export default new Router({
    routes: loginRoutes
});